import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { IStoreState } from "../../../../reducers/types";
import {
  fetchCalendarBuckets,
  setApplyUserHotelPreferences,
  setInitialStayType,
  setLocation,
  setLocationAutocompleteError,
  setLocationCategories,
  setOccupancyCounts,
  setPetsCount,
  setRoomsCount,
} from "../../actions/actions";
import {
  getApplyUserHotelPreferences,
  getHasLocationAutocompleteError,
  getInitialStayType,
  getLocation,
} from "../../reducer";
import { MobileHotelSearchControlV3 } from "./component";
import {
  getHasUserSetHotelPreferences,
  getUserHotelPreferencesCallState,
} from "../../../availability/reducer";

const mapDispatchToProps = {
  setLocationAutocompleteError,
  fetchCalendarBuckets,
  setApplyUserHotelPreferences,
  setLocation,
  setOccupancyCounts,
  setRoomsCount,
  setLocationCategories,
  setPetsCount,
  setInitialStayType,
};
const mapStateToProps = (state: IStoreState) => ({
  hasLocationAutocompleteError: getHasLocationAutocompleteError(state),
  userHasSetHotelPreferences: getHasUserSetHotelPreferences(state),
  userHotelPreferencesCallState: getUserHotelPreferencesCallState(state),
  shouldApplyUserHotelPreferences: getApplyUserHotelPreferences(state),
  hasLocation: !!getLocation(state),
  initialStayType: getInitialStayType(state),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileHotelSearchV3ConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileHotelSearchControlV3 = withRouter(
  connector(MobileHotelSearchControlV3)
);
